__turbopack_context__.v({
  "appDownloadBox": "styles-module__wCgASG__appDownloadBox",
  "authButtons": "styles-module__wCgASG__authButtons",
  "authenticatedNav": "styles-module__wCgASG__authenticatedNav",
  "closeButton": "styles-module__wCgASG__closeButton",
  "container": "styles-module__wCgASG__container",
  "depopLogo": "styles-module__wCgASG__depopLogo",
  "footer": "styles-module__wCgASG__footer",
  "getTheAppLink": "styles-module__wCgASG__getTheAppLink",
  "header": "styles-module__wCgASG__header",
  "headerContent": "styles-module__wCgASG__headerContent",
  "logoutButton": "styles-module__wCgASG__logoutButton",
  "mobileMenuWrapper": "styles-module__wCgASG__mobileMenuWrapper",
  "mobileMenuWrapper--hidden": "styles-module__wCgASG__mobileMenuWrapper--hidden",
  "mobileMenuWrapper--slideIn": "styles-module__wCgASG__mobileMenuWrapper--slideIn",
  "mobileMenuWrapper--slideOut": "styles-module__wCgASG__mobileMenuWrapper--slideOut",
  "navListItem": "styles-module__wCgASG__navListItem",
  "navListItemButton": "styles-module__wCgASG__navListItemButton",
  "navListItemLabel": "styles-module__wCgASG__navListItemLabel",
  "offerAlertContainer": "styles-module__wCgASG__offerAlertContainer",
  "offerAlertNotificationContainer": "styles-module__wCgASG__offerAlertNotificationContainer",
  "offerAlertText": "styles-module__wCgASG__offerAlertText",
  "primaryNav": "styles-module__wCgASG__primaryNav",
  "primaryNav--showBorderBottom": "styles-module__wCgASG__primaryNav--showBorderBottom",
  "primaryNav--showBorderTop": "styles-module__wCgASG__primaryNav--showBorderTop",
  "secondaryNavWrapper": "styles-module__wCgASG__secondaryNavWrapper",
  "selectWrapper": "styles-module__wCgASG__selectWrapper",
  "socialLink": "styles-module__wCgASG__socialLink",
  "socialLinks": "styles-module__wCgASG__socialLinks",
});
